<template>
  <div class="card flat">
    <div>
      <v-container class="timelineContainer">
        <v-timeline dense clipped id="timelinewidth" class="notes-section">
          <v-data-table
            hide-headers
            :headers="headerss"
            :items="dealNotes"
            
            class="elevation-1"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <td class style="overflow-x: hidden">
                <v-timeline-item
                  v-bind="{ class: 'fas fa-hand-holding-usd' }"
                  small
                  class="ma-0 pt-2"
                  fill-dot
                >
                  <template
                    v-slot:icon
                    v-if="
                      props.item.image_link != null ||
                      props.item.image_link != undefined
                    "
                  >
                    <img
                      v-bind:src="props.item.image_link"
                      style="height: 24px; width: 24px; border-radius: 50%"
                    />
                  </template>
                  <template v-slot:icon>
                    <i v-bind="{ class: 'fas fa-hand-holding-usd' }"></i>
                  </template>

                  <v-layout justify-space-between>
                    <v-flex xs10>
                      <v-chip
                        v-if="props.item.pinned"
                        class="white--text ml-0"
                        color="green"
                        label
                        small
                      >
                        {{
                          props.item.deal_note_type == "Ready2Fund"
                            ? "readytofund"
                            : "Pinned"
                        }}
                        <v-icon small right>flag</v-icon>
                      </v-chip>
                      <p class="caption pa-0 ma-0">
                        {{ formatDate(props.item.created_at) }}:
                        {{ props.item.name }} ({{
                          props.item.deal_note_processor_role
                        }})
                      </p>
                      <p
                        class="body-1 pa-0 ma-0"
                        v-html="props.item.deal_user_note"
                        style="
                          font-size: 13px !important;
                          max-width: 350px;
                          word-wrap: break-word;
                        "
                      ></p>
                    </v-flex>
                  </v-layout>
                </v-timeline-item>
              </td>
            </template>

            <template slot="no-data">
              <p>There are no notes for this submission</p>
            </template>

            <template slot="pageText" slot-scope="{ pageStart, pageStop }"
              >From {{ pageStart }} to {{ pageStop }}</template
            >
          </v-data-table>
        </v-timeline>
      </v-container>
    </div>
  </div>
</template>
<script>
// import { VueEditor } from "vue2-editor";
import axios from "axios";
import moment from 'moment'
import { URL } from "../../../env";
export default {
  components: {
    // VueEditor,
  },
  props: {
    contract_MID: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    headerss: [
      {
        text: "Notify All",
        align: "left",
        value: "deal_note_processor_role",
        sortable: false,
      },
    ],
    rowsPerPageItems: [{ text: "All", value: -1 }],
    pagination: {
      sortBy: "pinned",
      descending: true,
    },
    dealNotes: [],
  }),
  mounted() {
    this.get();
  },
  methods: {
    formatDate(date){
        return moment(date).format("L, h:mma")
    },
    get() {
      axios
        .get(`${URL}/api/submission_note/submission_notes`, {
          contract_MID: this.contract_MID,
          deal_note_type: "Collection",
        })
        .then((res) => {
            let pinned = _.filter(res.data, o=>o.pinned == 1)
            let not_pinned = _.filter(res.data, o=>!o.pinned)
            this.dealNotes = _.concat(pinned, not_pinned)
        });
    },
  },
};
</script>

<style>
#subhistorycomponent.v-toolbar__content {
  padding-bottom: 10px;
}
</style>

<style scoped>
.v-toolbar__content {
  height: 0px !important ;
}
#userList {
  max-height: 150px;
  overflow-y: scroll;
}
.elevation-1 {
  box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0.2), 0 0px 0px 0 rgba(0, 0, 0, 0.14),
    0 0px 0px 0 rgba(0, 0, 0, 0.12) !important;
}

.mytable .v-table tbody tr:not(:last-child) {
  border-bottom: none !important;
}

.btn-group button {
  float: left; /* Float the buttons side by side */
}

.btn-group:after {
  content: "";
  clear: both;
  display: table;
}

.v-timeline {
  margin: 0px !important;
  padding-top: 0px !important;
}

thead {
  display: none !important;
}

th {
  display: none !important;
}

.timelineContainer {
  padding: 0px;
}

.v-timeline-item {
  padding-bottom: 0px !important;
}

table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  height: 0px;
}
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 0px;
}
i.fas.fa-headset {
  color: white !important;
}

i.fas.fa-check-circle {
  color: white !important;
}

i.fas.fa-money-check-alt {
  color: white !important;
}

i.fas.fa-chart-line {
  color: white !important;
}

i.fas.fa-file-invoice-dollar {
  color: white !important;
}

i.fas.fa-male {
  color: white !important;
}

i.fas.fa-user-tie {
  color: white !important;
}
i.fas.fa-poo {
  color: brown !important;
}

i.fas.fa-keyboard {
  color: white !important;
}

i.fas.fa-file-signature {
  color: white !important;
}

i.fas.fa-hand-holding-usd {
  color: white !important;
}

i.fas.fa-briefcase {
  color: white !important;
}
.v-dialog.v-dialog--active.v-dialog--persistent {
  height: auto;
}
.v-card.v-sheet.theme--light {
  height: auto;
}
.v-btn--small {
  height: 0px;
  margin: 0px !important;
}

.caption {
  font-size: 11px !important;
}

.v-timeline-item {
  padding-bottom: 10px !important;
}

.notes-section {
  overflow-y: scroll;
  height: 370px;
  max-height: 370px;
}
</style>

<style>
#timelinewidth.v-timeline--dense .v-timeline-item__body {
  max-width: calc(100% - 35px) !important;
}
</style>